import { z } from 'zod';

const itemSchema = z.object({
	value: z.string(),
	label: z.string()
});

export const createProcessObjectSchema = z.object({
	name: z.string().min(1, { message: 'Name is required' }),
	voltageLines: z.array(itemSchema).nonempty('At least one line voltage is required'),
	primaryTtms: z.array(itemSchema).nonempty('Primary TTMS is required'),
	secondaryTtms: z.array(itemSchema).nonempty('Secondary TTMS is required')
});

export type CreateProcessObjectFormSchema = z.infer<typeof createProcessObjectSchema>;

export const LINE_VOLTAGE_OPTIONS = [765, 500, 345, 230, 161, 138, 120, 115, 69];
